module.exports = __webpack_public_path__ + "08_long_brown.9155260d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_long_brown.png
// module id = RwCp
// module chunks = 0